import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
/* eslint-disable @repo/internal/react/no-clone-element */


import React, { Component, Fragment } from 'react';
import { createAndFireEvent, withAnalyticsContext, withAnalyticsEvents } from '@atlaskit/analytics-next';
import toItemId from '../utils/to-item-id';
import Chevron from './internal/chevron';
import { TreeRowContainer } from './internal/styled';
var packageName = "@atlaskit/table-tree";
var packageVersion = "9.1.1";

var Row = /*#__PURE__*/function (_Component) {
  _inherits(Row, _Component);

  var _super = _createSuper(Row);

  function Row() {
    var _this;

    _classCallCheck(this, Row);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isExpanded: _this.props.isDefaultExpanded || false
    });

    _defineProperty(_assertThisInitialized(_this), "onExpandToggle", function () {
      var isExpanded = _this.props.isExpanded;

      if (isExpanded !== undefined) {
        _this.onExpandStateChange(!isExpanded);
      } else {
        _this.setState({
          isExpanded: !_this.state.isExpanded
        });

        _this.onExpandStateChange(!_this.state.isExpanded);
      }
    });

    return _this;
  }

  _createClass(Row, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          isDefaultExpanded = _this$props.isDefaultExpanded,
          isExpanded = _this$props.isExpanded;

      if (isExpanded === undefined && isDefaultExpanded !== undefined && prevProps.isDefaultExpanded !== isDefaultExpanded && this.state.isExpanded !== isDefaultExpanded) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          isExpanded: isDefaultExpanded
        });
      }
    }
  }, {
    key: "onExpandStateChange",
    value: function onExpandStateChange(isExpanded) {
      if (this.props.data) {
        if (isExpanded && this.props.onExpand) {
          this.props.onExpand(this.props.data);
        } else if (!isExpanded && this.props.onCollapse) {
          this.props.onCollapse(this.props.data);
        }
      }
    }
  }, {
    key: "isExpanded",
    value: function isExpanded() {
      var isExpanded = this.props.isExpanded;
      return isExpanded !== undefined ? isExpanded : this.state.isExpanded;
    }
  }, {
    key: "renderCell",
    value: function renderCell(cell, cellIndex) {
      var props = this.props;
      var isExpanded = this.isExpanded();
      var hasChildren = props.hasChildren,
          depth = props.depth;
      var isFirstCell = cellIndex === 0;
      var indentLevel = isFirstCell ? depth : 0;
      var cellContent = cell.props.children || [];

      if (isFirstCell && hasChildren) {
        cellContent = [/*#__PURE__*/React.createElement(Chevron, {
          key: "chevron",
          expandLabel: props.expandLabel,
          collapseLabel: props.collapseLabel,
          isExpanded: isExpanded,
          onExpandToggle: this.onExpandToggle,
          ariaControls: toItemId(props.itemId)
        })].concat(cellContent);
      }

      return /*#__PURE__*/React.cloneElement(cell, {
        key: cellIndex,
        columnIndex: cellIndex,
        indentLevel: indentLevel
      }, cellContent);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          hasChildren = _this$props2.hasChildren,
          depth = _this$props2.depth,
          renderChildren = _this$props2.renderChildren;
      var isExpanded = this.isExpanded();
      var ariaAttrs = {};

      if (hasChildren) {
        ariaAttrs['aria-expanded'] = isExpanded;
      }

      if (depth !== undefined) {
        ariaAttrs['aria-level'] = depth;
      }

      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(TreeRowContainer, _extends({
        role: "row"
      }, ariaAttrs), React.Children.map(this.props.children, function (cell, index) {
        return _this2.renderCell(cell, index);
      })), hasChildren && isExpanded && renderChildren && renderChildren());
    }
  }]);

  return Row;
}(Component);

export { Row as RowWithoutAnalytics };
var createAndFireEventOnAtlaskit = createAndFireEvent('atlaskit');
export default withAnalyticsContext({
  componentName: 'row',
  packageName: packageName,
  packageVersion: packageVersion
})(withAnalyticsEvents({
  onExpand: createAndFireEventOnAtlaskit({
    action: 'expanded',
    actionSubject: 'tableTree',
    attributes: {
      componentName: 'row',
      packageName: packageName,
      packageVersion: packageVersion
    }
  }),
  onCollapse: createAndFireEventOnAtlaskit({
    action: 'collapsed',
    actionSubject: 'tableTree',
    attributes: {
      componentName: 'row',
      packageName: packageName,
      packageVersion: packageVersion
    }
  })
})(Row));